<app-video-texte 
*ngIf="DynamicsHRTitres !== undefined && DynamicsHR!== undefined"
[STitleArrayCRM]="DynamicsHRTitres" [SParagrapheCRM]="DynamicsHR" [height]="height" [hr]="true" [IsFrench]="isFrench" [width]="Width"></app-video-texte>